import { BuyerInfoType } from './BuyerInfo';
import { IHydraBase } from './interfaces/hydra';
import { SellerInfoType } from './SellerInfo';
import { WarehouseType } from './Warehouse';

export interface IMeasurementEntry {
  fr?: string;
  en?: string;
  value?: string;
  unit?: string;
  convertedValue?: number;
  convertedUnit?: string;
  id?: number;
}

export interface IMeasurements {
  [param: string]: IMeasurementEntry;
}

export interface IItemDimensions {
  size?: IMeasurementEntry;
  measurements?: IMeasurements;
}

interface DeliveryCountryType extends IHydraBase {
  id: number;
  name: string;
  isoCode?: string;
}

export interface ProductType extends IHydraBase {
  id: number;
  warehouse: WarehouseType;
  relistParentId: number | null;
  price: number;
  images: string[];
  imageVersion: number;
  dimensions: IItemDimensions;
  seller: SellerInfoType | null;
  buyer: BuyerInfoType | null;
  additionalItems: string[];
  segment: string;
  deliveryCountry: DeliveryCountryType;
  purchasePlace: string | null;
  purcahseDate: string | null;
  authLevel: number | null;
  type: string;
  hasPublicComments: boolean;
  isVintage: boolean;
  comment: string | null;
  name: string;
  description: string;
  condition: string;
  category: string;
  link: string;
  brand: string;
  color: string;
  material: string;
  pattern: string;
  model: string | null;
  invoice: string | null;
  packaging: string | null;
  serialNumber: string | null;
  agentComment: string | null;
  notForSaleReasons: string[];
  hallmarks: string | null;
  weight: string | null;
  isShippingInSameFiscalMarket: boolean | null;
  cooId?: string | null;
  isWeightAndHallmarksAvailable: boolean;
  isWeightAndHallmarksRequired: boolean;
}

export enum PRODUCT_TYPES {
  JEWELRY = 'jewelry',
  WATCH = 'watch',
  BAG = 'bag',
}

export enum CommentBadge {
  Seller = 'Seller',
  Buyer = 'Buyer',
  Other = 'Other',
}

export interface ProductComment {
  description: string;
  customerEmail: string;
  langSource: string;
  createdAt: string;
  customerFirstName: string;
  customerLastName: string;
  commentBadge?: CommentBadge;
  commentAfterSale?: boolean;
}

export interface TranslateProductCommentType extends ProductComment {
  translation: string;
}

export type ProductOriginCountry = {
  legacyId: string;
  isConfirmed: boolean;
};
